import { defaultCryptographyRandom3hu9p6ooea5au as defaultCryptographyRandom } from './CryptographyRandom.web.mjs';
import {
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  Default_getInstancee1f46otjvolq as Default_getInstance,
  Random24dxadk52mliy as Random,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/random/Random.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var DefaultClass;
function Default() {
  if (DefaultClass === VOID) {
    class $ extends CryptographyRandom() {
      constructor() {
        return new.target.new_dev_whyoleg_cryptography_random_CryptographyRandom_Default_aond97_k$();
      }
      static new_dev_whyoleg_cryptography_random_CryptographyRandom_Default_aond97_k$() {
        Default_instance = null;
        var $this = this.new_dev_whyoleg_cryptography_random_CryptographyRandom_41b3eh_k$();
        Default_instance = $this;
        $this.defaultRandom_1 = defaultCryptographyRandom();
        return $this;
      }
      nextBits_kty4bl_k$(bitCount) {
        return this.defaultRandom_1.nextBits_kty4bl_k$(bitCount);
      }
      nextInt_ujorgc_k$() {
        return this.defaultRandom_1.nextInt_ujorgc_k$();
      }
      nextInt_ak696k_k$(from, until) {
        return this.defaultRandom_1.nextInt_ak696k_k$(from, until);
      }
      nextDouble_s2xvfg_k$() {
        return this.defaultRandom_1.nextDouble_s2xvfg_k$();
      }
      nextBytes_ln07bs_k$(array) {
        return this.defaultRandom_1.nextBytes_ln07bs_k$(array);
      }
      nextBytes_ykc5js_k$(array, fromIndex, toIndex) {
        return this.defaultRandom_1.nextBytes_ykc5js_k$(array, fromIndex, toIndex);
      }
    }
    initMetadataForObject($, 'Default');
    DefaultClass = $;
  }
  return DefaultClass;
}
var Default_instance;
function Default_getInstance_0() {
  if (Default_instance === VOID) {
    Default_getInstance();
    Default().new_dev_whyoleg_cryptography_random_CryptographyRandom_Default_aond97_k$();
  }
  return Default_instance;
}
var CryptographyRandomClass;
function CryptographyRandom() {
  if (CryptographyRandomClass === VOID) {
    class $ extends Random() {
      static new_dev_whyoleg_cryptography_random_CryptographyRandom_41b3eh_k$() {
        Default_getInstance_0();
        return this.new_kotlin_random_Random_3b5oio_k$();
      }
    }
    initMetadataForClass($, 'CryptographyRandom');
    CryptographyRandomClass = $;
  }
  return CryptographyRandomClass;
}
//region block: exports
export {
  CryptographyRandom as CryptographyRandom7x2mkp21hkpe,
  Default_getInstance_0 as Default_getInstance1zramwb175hhz,
};
//endregion

//# sourceMappingURL=CryptographyRandom.mjs.map
